module.exports = __webpack_public_path__ + "static/media/city1-lowOpacityblue-01.9c797686.png";